
interface UnarchiveIconProps {
  size?: number;
  color?: string;
  title?: string;
}

export default function UnarchiveIcon({ size = 24, color = 'currentColor', title }: UnarchiveIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {title && <title>{title}</title>}
      {/* Lid (tilted) */}
      <rect
        x="2.8"
        y="4.6"
        width="18"
        height="4"
        rx="1.5"
        transform="rotate(-30 11.8 6.6)"
      />
      {/* Box outline */}
      <path d="M4.5 12 V18 a2 2 0 0 0 2 2 H17.5 a2 2 0 0 0 2 -2 V7" />
      {/* Handle */}
      <rect x="9" y="13" width="6" height="2.25" rx="1.125" />
    </svg>
  );
}
